import { defineMessages } from 'react-intl';

export const fallbackRDEHeadlines = defineMessages({
  criteoFallback: {
    defaultMessage: 'Gesponserte Artikel',
    id: 'rde.criteo-products.headline-fallback',
  },
  seriesFallback: {
    defaultMessage: 'Mehr aus dieser Serie',
    id: 'rde.series.headline-fallback',
  },
});
